import React, { useEffect, useState } from 'react';
import { Checkbox, Grid } from '@material-ui/core';
import DefaultTable from 'app/internalPages/Lines/components/DefaultTable';
import helpers from 'app/utils/helpers';

const defaultColumnOrder = {
    deCpfCnpj: 0,
    deNomePermissionario: 1,
    cdLinhaPermissionario: 2,
    autorizadoComponent: 3,
}
/**
 * Component PermissionariesTable.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {Array} props.data - Dados de permissionários exibidos na tabela.
 * @param {Function} props.setData - Função para atualizar os dados da tabela.
 * @param {boolean} props.loading - Indica se os dados estão sendo carregados.
 * @param {boolean} [props.isInternalForm=false] - Define se o formulário é interno. Valor padrão é `false`.
 * @param {boolean} props.disabled - Indica se o componente está desabilitado.
 * @param {Function} props.setChanged - Função para indicar que houve mudanças nos dados.
 * @param {boolean} props.isPaginated - Indica se é tabela é paginada.
 * @param {Object} props.columnsOrder - Possibilita informar as ordens das colunas, caso não seja informado, será utilizado a ordenação default.
 *
 * @returns {JSX.Element} O componente PermissionariesTable.
 */
const PermissionariesTable = ({
                                  data, setData, loading, isInternalForm = false,
                                  disabled, setChanged, isPaginated = true, columnsOrder = defaultColumnOrder }) => {
    const [pageSize, setPageSize] = useState(10);
    const [allRows, setAllRows] = useState([]);
    const [page, setPage] = useState(0);
    const [rows, setRows] = useState([]);

    const handleChangePage = (e, page) => {
        setPage(page);
    };

    const handleChangePageSize = (e) => {
        setPageSize(parseInt(e.target.value));
    };

    const handleChangePermissionary = (e, id) => {
        const checked = e.target.checked;
        const tempAllRows = allRows.map((row) => {
            const temp = { ...row };
            if (temp.tempId === id) {
                temp.boAutorizado = checked;
            }
            return temp;
        });
        setData(tempAllRows);
        if (setChanged) setChanged(true);
    };

    const prepareRows = (dataParam) => {
        let list = dataParam;
        if(isPaginated && pageSize > 0) list = dataParam.slice(page * pageSize, page * pageSize + pageSize);
        list = list.map((row) => {
            const temp = { ...row };
            temp.autorizadoComponent = (
                <Checkbox
                    color={'primary'}
                    checked={!temp.boAutorizado ? false : temp.boAutorizado}
                    onChange={(e) => handleChangePermissionary(e, temp.tempId)}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                />
            );
            temp.deCpfCnpj = helpers.formatarDocumento(temp.deCpfCnpj ? temp.deCpfCnpj : '');
            return temp;
        });
        return list;
    };

    const renderColumns = () => {
        const temp = [
            { id: 0, fieldName: 'deCpfCnpj', title: 'CPF / CNPJ', colOrder: columnsOrder.deCpfCnpj },
            { id: 1, fieldName: 'deNomePermissionario', title: 'Nome do permissionário', colOrder: columnsOrder.deNomePermissionario },
            { id: 2, fieldName: 'nuPermissionario', title: 'Número de cadastro', colOrder: columnsOrder.cdLinhaPermissionario },
        ];
        if (isInternalForm && !disabled) {
            temp.push({ id: 3, fieldName: 'autorizadoComponent', title: '', colOrder: columnsOrder.autorizadoComponent });
        }
        temp.sort((a, b) => a.colOrder - b.colOrder);
        return temp;
    };

    useEffect(() => {
        (() => {
            setAllRows(data || []);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    useEffect(() => {
        (() => {
            setRows(prepareRows(allRows));
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, pageSize, allRows]);

    return (
        <Grid item xs={12}>
            <h3 style={{ fontWeight: '500' }}>Permissionários</h3>
            <DefaultTable
                columns={renderColumns()}
                rows={rows}
                size={'small'}
                loading={loading}
                paginationProps={isPaginated ? {
                    rowsPerPageOptions: [5, 10, 25],
                    count: allRows.length || 0,
                    rowsPerPage: pageSize,
                    page: page,
                    onPageChange: handleChangePage,
                    onRowsPerPageChange: handleChangePageSize,
                } : null}
            />
        </Grid>
    );
};

export default PermissionariesTable;
